import App from 'unsubscribe-ui/App';
new App().start();